<template>
  <section id="testimonials" class="section-padding bg-gray-50">
    <div class="container-custom">
      <!-- Section Header -->
      <div class="text-center mb-16">
        <div class="inline-flex items-center px-4 py-2 rounded-full bg-primary-100 text-primary-800 text-sm font-medium mb-6">
          <i class="fas fa-star mr-2"></i>
          Customer Reviews
        </div>
        <h2 class="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
          Loved by
          <span class="gradient-text">Many Users</span>
        </h2>
      </div>
      
      <!-- Overall Rating -->
      <div class="mt-16 text-center">
        <div class="bg-white rounded-2xl shadow-lg p-8 max-w-4xl mx-auto">
          <div class="flex items-center justify-center mb-6">
            <div class="text-6xl font-bold text-gray-900 mr-4">4.9</div>
            <div class="text-left">
              <div class="flex text-yellow-400 text-2xl mb-2">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>
            </div>
          </div>
          <p class="text-xl text-gray-700 italic">
            "Task Manager Pro consistently receives 5-star reviews for its ease of use, 
            powerful features, and excellent customer support."
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TestimonialsSection'
}
</script>


